import actionTypes from "./actionTypes.js";
import namespace from './namespace';
export default {
  namespace,
  state: {
    coursePackageDetail: {},
    customConfig: {}
  },
  reducers: {
    [actionTypes.SET_COURSE_PACKAGE_DETAIL](state, action) {
      return { ...state,
        coursePackageDetail: { ...action.data
        }
      };
    },

    [actionTypes.SET_COURSENAME](state, action) {
      return { ...state,
        customConfig: { ...action.data
        }
      };
    }

  }
};